export default {
  'add.png': 'add.png',
  'cert.png': 'cert.png',
  'enter.png': 'enter.png',
}
